import React from 'react';
import { LinkCheckerRun } from '../repository/linkCheckerRepository';

interface RunDetailsProps {
  run: LinkCheckerRun;
}

const statusPillClass = (status: string): string => {
  switch (status) {
    case 'SUCCEEDED':
    case 'PASS':
      return 'succeeded';
    case 'FAILED':
    case 'FAIL':
      return 'failed';
    case 'IN_PROGRESS':
      return 'in-progress';
    default:
      return '';
  }
};

const RunDetailsComponent: React.FC<RunDetailsProps> = ({ run }) => {
  const formatTimestamp = (isoString: string) => {
    return new Date(isoString).toLocaleString();
  };

  return (
    <div className="run-card">
      <h3>Run ID: {run.run_id}</h3>
      <p><strong>Description:</strong> {run.description}</p>
      <p><strong>Timestamp:</strong> {formatTimestamp(run.timestamp)}</p>
      <p>
        <strong>Status:</strong>{' '}
        <span className={`status-pill ${statusPillClass(run.status_result)}`}>
          {run.status_result}
        </span>
      </p>
      {run.failures && run.failures.length > 0 && (
        <div>
          <h4>Broken Links:</h4>
          <ul>
            {run.failures.map((failure, index) => (
              <li key={index}>{failure}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default RunDetailsComponent;
